import { IComponentController } from 'angular';
import { IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IStateParamsService, IStateService } from 'angular-ui-router';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';

interface IPageAl2008 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    dlaMultiOccurrenceOptions: IMultiOccurrenceOptions;
    dlaMultiOccurrence: IMultiOccurrence;
}

/* @ngInject */
export default function Al2008Controller(MenuItemAction: IMenuItemActionClass, 
    $state: IStateService,
    al0004Route: IRoute,
    ecranDetails: IEcranDetailsResourcesEntite,
    $stateParams: IStateParamsService) {
    const vm: IPageAl2008 = this;
    vm.valeursEcran = ecranDetails.valeurs;

        const menuItemRepartition = new MenuItemAction(
            '',
            'BOUACTABS',
            (data: any) => ({
                dlhcleint: data.dlhcleint,
                dlacleint: data.dlacleint
            }),
            {
                icon: (data: any) => {
                    if (!data.dlaflggenabs) {
                        return 'radio_button_unchecked';
                    } else return 'check_circle';
                },
                successAction: () => {
                    vm.dlaMultiOccurrence.fetchDataList();
                }
            }
        );
        vm.monoOccurrenceOptions = {
            fonctions: {
                afficherMenusDansEntete: true
            },
            menus: [
                new MenuItemAction('LBL_BTN_GEN', 'BOUGEN', () => ({}), {
                    fonction: 'BOUGEN',
                    saveFirst: true,
                    iconButton: false,
                    class: 'md-raised ex-button-action',
                    successAction: () => $state.go(
                        al0004Route.NAME, {
                        id: $stateParams.dlhcleint,
                        dlpcleint: $stateParams.dlpcleint,
                        menuId: $state.params.menuId
                    })
                })
            ]
        };
        vm.dlaMultiOccurrenceOptions = {
            fonctions: {
                suiviModification: false
            },
            colonnesFixesGauche: [{ nom: 'dlaflggenabs', menu: [menuItemRepartition], replacedValue: ' ', largeur: 90 }],
            colonnesVisibles: [
                { nom: 'aftcod', largeur: 104 },
                { nom: 'aftdscfmt', largeur: 280 },
                { nom: 'dlaqte', largeur: 87 },
                { nom: 'dladursem', largeur: 100 },
                { nom: 'dlaflgremaut', largeur: 113 }
                
            ]
        };    
}
